export function ModuleViewer ({ payload }) {
  return payload?.url ? (
    <iframe
      title="Slido"
      width="100%"
      height="100%"
      src={payload?.url}
      frameBorder="0"
    />
  ) : (
    <div className="flex justify-center items-center h-full">
      <span className="text-lg font-semibold text-gray-600">[Slido link missing]</span>
    </div>
  )
}

export function ModuleEditor ({ payload, onUpdatePayload }) {

  function onUpdate (key, value) {
    const newPayload = { ...payload, [key]: value }
    onUpdatePayload(newPayload)
  }

  return (
    <div className="space-y-3">
      <div>
        <label htmlFor="slido-url" className="block text-sm font-medium text-gray-700">
     Slido URL
        </label>
        <div className="mt-1">
          <input
            type="text"
            name="slido-url"
            id="slido-url"
            className="px-2 h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="https://app.sli.do/event/..."
            value={payload?.url || ''}
            onChange={(e) => onUpdate('url', e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}
